import SurveysService from "@/services/SurveysService";

export default {
  data() {
    return {
      SurveyInstanceStatus: SurveysService.SurveyInstanceStatus,
      SurveyInstanceStatusDeletedStatuses: [
        SurveysService.SurveyInstanceStatus.Deleted,
        SurveysService.SurveyInstanceStatus.DeletedShopper,
        SurveysService.SurveyInstanceStatus.DeletedAgency,
        SurveysService.SurveyInstanceStatus.DeletedInternal,
        SurveysService.SurveyInstanceStatus.DeletedExternal,
        SurveysService.SurveyInstanceStatus.Delete
      ]
    };
  },

  computed: {
    getSurveyInstanceStatusOptions() {
      return [
        { value: this.SurveyInstanceStatus.Released, text: this.getSurveyInstanceStatusText(this.SurveyInstanceStatus.Released) },
        { value: this.SurveyInstanceStatusDeletedStatuses.join(','), text: this.getSurveyInstanceStatusText(this.SurveyInstanceStatus.Deleted) },
        { value: this.SurveyInstanceStatus.InternalUse, text: this.getSurveyInstanceStatusText(this.SurveyInstanceStatus.InternalUse) },
        { value: `<=${this.SurveyInstanceStatus.Processing}`, text: this.getSurveyInstanceStatusText(this.SurveyInstanceStatus.Processing) }
      ];
    }
  },

  methods: {
    getSurveyInstanceStatusIcon(statusId) {
      if (statusId <= this.SurveyInstanceStatus.Processing) {
        return 'cogs';
      } else if (statusId == this.SurveyInstanceStatus.Released) {
        return 'check';
      } else if (statusId == this.SurveyInstanceStatus.InternalUse) {
        return 'lock';
      } else if (this.SurveyInstanceStatusDeletedStatuses.includes(statusId)) {
        return 'trash-alt';
      }

      return 'check';
    },

    getSurveyInstanceStatusText(statusId) {
      if (statusId <= this.SurveyInstanceStatus.Processing) {
        return this.$t('Webportal.StatusProcessing');
      } else if (statusId == this.SurveyInstanceStatus.Released) {
        return this.$t('Webportal.StatusOK');
      } else if (statusId == this.SurveyInstanceStatus.InternalUse) {
        return this.$t('Webportal.StatusInternal');
      } else if (this.SurveyInstanceStatusDeletedStatuses.includes(statusId)) {
        return this.$t('Webportal.StatusDeleted');
      }

      return this.$t('Webportal.StatusProcessing');
    }
  }
};
